import { Link } from "react-router-dom";
import { ArrowRight, CircleCheck } from "lucide-react";
import { APP_ROUTES } from "../../routes/AppRoutes";
import startaproject from '../../assets/images/whatwedo/eventsExperiences/startaproject.jpg';

const POINTS = [
  "Tell us the occasion, date and audience",
  "We come back with a concept and a quote",
  "One team takes it from there",
];

// Content is overridable so other pages (e.g. Influencer Marketing) can reuse the CTA.
const EventsCta = ({
  image = startaproject,
  eyebrow = "Start a project",
  title = "Planning an event or launch?",
  accent = "Send us the brief.",
  intro,
  points = POINTS,
}) => (
  <section className="ee-section">
    <div className="container">
      <div className="ee-cta" data-aos="zoom-in-up" data-aos-once="true">
        <img className="ee-cta-image" src={image} alt="" loading="lazy" decoding="async" />
        <div className="ee-cta-content">
          <span className="ee-eyebrow ee-eyebrow--line">{eyebrow}</span>
          <h2 className="ee-title ee-cta-title">
            {title} <span>{accent}</span>
          </h2>
          {intro && <p className="ee-intro">{intro}</p>}
          {points.length > 0 && (
            <ul className="ee-checks">
              {points.map((point) => (
                <li key={point}>
                  <CircleCheck size={18} /> {point}
                </li>
              ))}
            </ul>
          )}
          <Link to={APP_ROUTES.CONTACT_US} className="ee-btn">
            Contact Us <ArrowRight size={16} />
          </Link>
        </div>
      </div>

      <div className="ee-strip">
        <span>
          251, Phase 4, Udyog Vihar, Sector 18, Gurugram ·{" "}
          <a href="mailto:support@hkimedia.com">Support@hkimedia.com</a>
        </span>
        <span>Influencer · Celebrity · AI Content · Events</span>
      </div>
    </div>
  </section>
);

export default EventsCta;
